import React from 'react';

const SubmitButton = ({submitHandler,text}) => {
  return (
    <button
    type="submit"
    className="btn-primary form-btn"
    data-bs-toggle="modal"
    data-bs-target="#exampleModalCenter"
    onClick={(e) => {
        submitHandler(e);
    }}
  >
    {/* {!Build_Id ? "Add now" : "Update now"} */}
    {text}
  </button>
  )
}

export default SubmitButton